import styles from "./ProgressBar.module.scss";

export default function ProgressBar({maxValue = 100, value = 0, className = ""}) {
  return <div className={`${styles.progressBar} ${className}`} style={{width: `${(100 / maxValue) * value}%`}} />;
}
